<template>
  <div class="d-book-user-review-entry">
    <DBookUserReviewAuthor
      v-once
      :avatar-url="userReview.user.avatar_url"
      :has-video-review="!!userReview.video_url"
      :published-at="userReview.published_at"
      :rating="userReview.verdict.rating"
      :user-name="`${ userReview.user.firstname } ${ userReview.user.lastname }`"
      :user-slug="userReview.user.slug"
      :user-url="userReview.user.url"
    />

    <p
      v-if="!!userReview.overview"
      v-once
      class="font-alt space-top-1em space-bottom-2em"
    >
      <span class="overview">{{ userReview.overview }}</span>

      <a
        class="read-more bold"
        :href="userReview.url"
        title="Read more"
      >
        Read more...
      </a>
    </p>

    <DBookUserReviewSocial
      v-if="!!userReview.overview"
      :is-user-signed-in="isUserSignedIn"
      :user-review="userReview"
    />
  </div>
</template>

<script>
import DBookUserReviewAuthor from './d-book-user-review-author/d-book-user-review-author.vue';
import DBookUserReviewSocial from './d-book-user-review-social/d-book-user-review-social.vue';

export default {
  components: {
    DBookUserReviewAuthor,
    DBookUserReviewSocial,
  },
  props: {
    isUserSignedIn: {
      type: Boolean,
      default: false,
    },
    userReview: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-book-user-review-entry {
  border-bottom: $border-width-base solid getColor($grey, medium);
  padding: $_2em 0;
}
</style>
